import { BaseApi } from './base.api.js';

export class AssessmentQuestionApi extends BaseApi {
    constructor(client) {
        super(client, '/assessment-question');
    }

    getByIds(ids) {
        return this.client.post(`${this.basePath}/by-ids`, { ids });
    }
}
